import Vue from 'vue'

Vue.filter('discountPercentage', (value, compareAtPrice) => {
  return Math.floor(((compareAtPrice - value) / compareAtPrice) * 100)
})
